import { render } from "./AdminAcquisition.vue?vue&type=template&id=72c5b2fd&scoped=true"
import script from "./AdminAcquisition.vue?vue&type=script&lang=js"
export * from "./AdminAcquisition.vue?vue&type=script&lang=js"

import "./AdminAcquisition.vue?vue&type=style&index=0&id=72c5b2fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c5b2fd"]])

export default __exports__